<script setup></script>

<template>
  <Toast />
  <router-view />
</template>

<style scoped></style>
